import gql from 'graphql-tag';

import {
  printProductSizeRoesGraphicNodeDetails,
  printProductSizeServiceDetails,
} from '../../../../graphql/fragments/print-product';

const accountCardPrintProductConfiguration = gql`
  fragment accountCardPrintProductConfiguration on AccountCard {
    print_product_configuration {
      print_product {
        id
        name
        is_standard
        card {
          id
        }
      }
      print_product_size {
        id
        print_size {
          id
          name
          width
          height
        }
      }
      print_product_size_mount {
        id
        print_mount {
          id
          name
        }
      }
      print_product_size_services {
        total
        records {
          id
          print_product_size_service {
            ...printProductSizeServiceDetails
          }
        }
      }
      print_product_size_roes_graphic_node {
        ...printProductSizeRoesGraphicNodeDetails
      }
      name
      total_price {
        value
        currency
      }
    }
  }
  ${printProductSizeServiceDetails}
  ${printProductSizeRoesGraphicNodeDetails}
`;

export default accountCardPrintProductConfiguration;
